import React from 'react';
import styles from './styles.scss';

function ProductFAQ() {
  return (
    <div className="container-fluid main-container">
      <div className="row">
        <div className="col-md-7 col-center col-sm-12">
          <div className={`${styles.container} row mt20 mb20`}>
            <div className="col-sm-6 plr20">
              <div className="p demi-bold mt40 mb20">
                Do you build and host the site?
              </div>
              <div className="p text-justify light">
                We don't host any websites or apps. Althought, we will provide
                ready-to-build digital assets for your development team or dev
                of choice to code for you. Everything will be packaged,
                including fonts, icons, photos, and UI styles.
              </div>
            </div>
            <div className="col-sm-6 plr20">
              <div className="p demi-bold mt40 mb20">
                What if I don't like the design in the end?
              </div>
              <div className="p text-justify light">
                It is unlikely, but if it does happen, we'll assign your project
                to another designer free of charge until we meet your
                satisfaction. If it still isn't working out, we'll honor a 100%
                money-back guarantee!
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductFAQ;



// WEBPACK FOOTER //
// ./src/components/ProductFAQ/index.js